module.exports = __webpack_public_path__ + "img/theCover_11.25969336.jpg";